import { render, staticRenderFns } from "./SectionDispenser.vue?vue&type=template&id=3b48e4d6&scoped=true&"
import script from "./SectionDispenser.vue?vue&type=script&lang=js&"
export * from "./SectionDispenser.vue?vue&type=script&lang=js&"
import style0 from "./SectionDispenser.vue?vue&type=style&index=0&id=3b48e4d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48e4d6",
  null
  
)

export default component.exports